import React, { useState } from 'react';

import UserSignIns from "../tables/userSignIns";
import LineChartHistoricUsers from "../graphs/lineChartHistoricUsers";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import NavBarMenu from '../NavBarMenu';
import FooterMenu from '../FooterMenu';

function Users() {
    const [value, setValue] = useState(30);
    const handleChanges = (newValue) => {
        setValue(newValue) 
    }

    const [instance, setInstance] = useState();
    const handleInstanceChanges = (newInstance) => {
        setInstance(newInstance) 
    }

    return (
      <>
        <NavBarMenu handleInstanceChanges={handleInstanceChanges} handler={handleChanges} />
        <main>
            <Container fluid>
            <Row className="display-flex">
                <Col>
                    <LineChartHistoricUsers/>
                </Col>
            </Row>
            <Row className="display-flex">
                <Col >     
                    <UserSignIns instance={instance} value={value} />
                </Col>
            </Row>
            </Container>
        </main>
        <FooterMenu />
      </>
    );
}
export default Users